<template>
  <div class="content">
    <div class="logo">
      <img style="width:100%;height:100%" :src="HERF+'/backstage/kycx.png'" alt="" />
    </div>

    <div class="input-box">
      <div class="input-box-left"><i class="iconfont icon-shouji"></i></div>
      <div class="input-box-right">
        <input
          type="text"
          v-model="mobile"
          placeholder="请输入手机号码"
          @change="oninputmobile"
          maxlength="11"
        />
      </div>
    </div>

    <div class="input-box">
      <div class="input-box-left"><i class="iconfont icon-gou1"></i></div>
      <div class="input-box-right">
        <input type="text" placeholder="请输入验证码" v-model="code" />
      </div>
      <div class="get-code" @click="get_code" v-show="count == 60">
        获取验证码
      </div>
      <div class="get-code count" v-show="count < 60">{{ count }}秒重试</div>
    </div>

    <div class="login-btn" @click="login">登录</div>

    <div class="ps">
      登陆即表示已阅读并同意<span>《天翼账号服务与协议》</span>
      、<span>《用户协议》</span>与<span>《隐私政策》</span>并授权可以测获得本机号码
    </div>

    <div class="division">
      <span>or</span>
    </div>

    <div class="login-mode">
      <div @click="wxsignin" style="display:flex;justify-content: center;">
        <!-- <img src="../../assets/wechat.png" alt="" /> -->
        <p style="border-bottom: 1px solid blue;color:blue">海外用户登录</p>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:登录
@createTime:2021-09-02
@create:wq
*/
import {HERF,getAppid,getQueryString,DEFAULTAPPID} from '@/utils/tool'
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      mobile: "",
      code: "",
      count: 60,
      HERF:HERF
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    let code = getQueryString("code");
    let state = getQueryString("state");
    if(state){
      console.log(state.indexOf('10'),'--====-000000000000-------------');
    }
    console.log(code,state,'--====-000000000000-------------');
    if (state && code && state.indexOf('10') < 0) {
      this.getWxUserInfo(code);
    }
    //手机号绑定微信
    if (state && state.indexOf('10') >=0 && code) {
      this.tokenBindOpenid(code);
    }
  },
  methods: {
    login() {
      if (!this.mobile) {
        return this.Toast("手机号不能为空");
      }
      if (!this.code) {
        return this.Toast("验证码不能为空");
      }
      let userCode = sessionStorage.getItem("userCode");
      this.api
        .login({ mobile: this.mobile, code: this.code, userCode: userCode })
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.data));
          localStorage.setItem("token", res.data.api_token);
          //手机登录未绑定微信
          if (res.data.bindOpenID == 0) {
            this.wxsignin(10);
            // console.log(2222)
          } else {
            //已经绑定
            if (this.$route.query && this.$route.query.redirect) {
              this.$router.replace(this.$route.query.redirect);
            } else {
              this.$router.go(-1);
            }
          }
        });

      // const res = {
      //   id: 1,
      //   account: "KYC_a8afaabbc6abc20762a88b24c88b5163",
      //   username: "hello world",
      //   nickname: "hello world",
      //   mobile: "15082576703",
      //   email: null,
      //   avatar:
      //     "http://kyc.anagelink.cn/upload/interrogation/20210926/lT1p25QQOdnr2Ysk4n8EGP2zHRSXi2KmStG81bFE.jpg",
      //   sex: "1",
      //   region: null,
      //   birthday: null,
      //   openid: null,
      //   api_token: "dlv20XcmREHgWvNE",
      //   examine: 1,
      //   fp: null,
      //   del: "0",
      //   created_at: "2021-09-26T02:08:51.000000Z",
      //   updated_at: "2021-09-26T03:42:02.000000Z",
      //   is_teacher: 0,
      //   price: "0.00",
      //   all_price: "0.00",
      //   pid: 0,
      //   year: "1970-01-01",
      //   lunar: 0,
      //   time: "子时 23:00-00:59",
      //   gold: 0,
      //   deactivate: 0,
      //   bindOpenID: 1,
      //   isPerfect: 1,
      // };
      // localStorage.setItem("user", JSON.stringify(res));
      // localStorage.setItem("token", res.api_token);

      // if (this.$route.query && this.$route.query.redirect) {
      //   this.$router.replace(this.$route.query.redirect);
      // } else {
      //   this.$router.go(-1);
      // }
    },
    //手机登录绑定信息
    tokenBindOpenid(code) {
      this.api.TokenBindOpenid({ code: code }).then(() => {
        let user = JSON.parse(localStorage.getItem("user"));
        user.bindOpenID = 1;
        localStorage.setItem("user", JSON.stringify(user));
        const url = location.origin + location.pathname + location.hash;
        history.pushState({}, "", url);
        this.$router.replace("mine");
        window.history.replaceState();
      });
    },
    // 获取验证码
    get_code() {
      if (!this.mobile) {
        return this.Toast("手机号不能为空");
      }
      
      this.api.getCode({ mobile: this.mobile, type: "login" }).then((res) => {
        this.Toast("发送成功");
        if(res.data && res.data.code){
          this.code = res.data.code;
        }
        this.count -= 1;
        let a = setInterval(() => {
          this.count -= 1;
          if (this.count == 1) {
            this.count = 60;
            clearInterval(a);
          }
        }, 1000);
      });
    },
    wxsignin(type = 0) {
      // const appid = "wx47e921a6c75be7e1";
      const appid = getAppid() ? getAppid() : DEFAULTAPPID;
      console.log(appid);
      // const url = location.origin + location.pathname + '?appid='+appid + location.hash;
      const url = location.origin + location.pathname + '?appid='+appid + '#/login';
      localStorage.setItem('appid',appid)
      const redirect_uri = encodeURIComponent(url);
      console.log(redirect_uri);
      if (type == 1) {
        // this.Toast("type1");
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${type}#wechat_redirect`;
      } else {
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${type}#wechat_redirect`;
      }
    },
    oninputmobile() {
      if (!/^1[34578]\d{9}$/.test(this.mobile)) {
        this.Toast("手机号码有误，请重填");
      }
    },
    getWxUserInfo(code) {
      console.log('getInfo-----------------');
      let userCode = sessionStorage.getItem("userCode");
      this.api.getWxUserInfo({ code, userCode: userCode }).then((res) => {
        localStorage.setItem("user", JSON.stringify(res.data));
        localStorage.setItem("token", res.data.api_token);
        // const url = location.origin + location.pathname + location.hash;
        // history.pushState({}, "", url);
        // this.$router.replace("mine");
        const appid = localStorage.getItem('appid');
        location.href = HERF + '/h5?appid='+appid + '#/mine';
      });
    },
    // getQueryVariable(variable) {
    //   var query = window.location.search.substring(1);
    //   var vars = query.split("&");
    //   for (var i = 0; i < vars.length; i++) {
    //     var pair = vars[i].split("=");
    //     if (pair[0] == variable) {
    //       return pair[1];
    //     }
    //   }
    //   return false;
    // },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: 100vh;
  background-image: url(../../assets/login.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  //   background-position: center;
}
.logo {
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border-radius: 50%;
  background-color: #4fd9d5;
  margin: 1.28rem auto 1.26rem;
}
.input-box {
  margin: 0 0.62rem;
  margin-bottom: 0.42rem;
  height: 1rem;
  background: #f0f0f0;
  border: 1px solid #e6e6e6;
  border-radius: 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-right: 0.06rem;
  .input-box-left {
    width: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 0.4rem;
      color: #cccccc;
    }
  }
  .input-box-right {
    flex: 1;
    width: 100%;
    height: 100%;
    input {
      width: 100%;
      height: 100%;
      border: none;
      background-color: transparent;
      font-size: 0.3rem;
    }
  }
  .get-code {
    width: 2.12rem;
    height: 0.88rem;
    border-radius: 0.44rem;
    background-color: #4fd9d5;
    font-size: 0.3rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.login-btn {
  margin: 0 0.62rem;
  height: 1rem;
  background: #4fd9d5;
  box-shadow: 0px 3px 6px rgba(79, 217, 213, 0.3);
  border-radius: 0.5rem;
  font-size: 0.36rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.76rem;
}
.ps {
  margin: 0 0.24rem;
  font-size: 0.24rem;
  color: #cccccc;
  text-align: center;
  margin-top: 0.72rem;
  span {
    color: #4fd9d5;
  }
}
.division {
  margin: 0.3rem 0.24rem;
  height: 1px;
  background-color: #e6e6e6;
  position: relative;
  span {
    font-size: 0.36rem;
    font-weight: 400;
    color: #e6e6e6;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    padding: 0 0.4rem;
  }
}

.login-mode {
  display: flex;
  justify-content: center;
  margin-top: 0.6rem;
  img {
    width: 1.2rem;
  }
  p {
    font-size: 0.3rem;
    color: #999999;
    text-align: center;
  }
}
.count {
  background: #999999 !important;
}
</style>
